var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"past-container",style:(_vm.getSlotHeight)},[_c('div',{staticClass:"past-inner tooltip",on:{"mousemove":_vm.showIsPast}},[_c('span',{attrs:{"id":"tooltip-span"}},[_vm._v(" This hour has passed. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }